import { useEffect } from 'react';
import { useAppSelector } from '../hooks/useAppSelector';
import { isTokenExpired, logout, refreshToken } from '../store/slices/auth';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from '../hooks/useAppDispatch';
import axios, { AxiosError } from 'axios';

const SessionManager = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const auth = useAppSelector((state) => state.auth);
    const isSampleUser = auth.tokenData?.data?.isSample;

    // Axios 401 interceptor
    useEffect(() => {
        if (isSampleUser) return;

        const interceptor = axios.interceptors.response.use(
            (response) => response,
            (error: AxiosError) => {
                if (error?.response?.status === 401) {
                    console.log('SessionManager: 401 received');
                    dispatch(logout());
                    history.push('/session-expired');
                }
                return Promise.reject(error instanceof Error ? error : new Error(error));
            }
        );

        return () => {
            axios.interceptors.response.eject(interceptor);
        };
    }, [dispatch, history, isSampleUser]);

    useEffect(() => {
        if (isSampleUser) return;

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible' && auth?.tokenData?.exp) {
                if (isTokenExpired(auth.tokenData.exp)) {
                    console.log('SessionManager: token expired on visibility');
                    dispatch(logout());
                    history.push('/session-expired');
                } else {
                    console.log('SessionManager: refreshing token');
                    void dispatch(refreshToken());
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [dispatch, auth, history, isSampleUser]);

    return null;
};

export default SessionManager;
